import { axiosInstance } from "./apiInstance";

export const postNewTag = ({ tagType, payload }) => {
  return axiosInstance.post(`/api/inkle/tags/create/${tagType}/`, payload);
};
